module.exports = __webpack_public_path__ + "static/media/__File-Manager.dbfcc8af.svg";